import { getUTCDate } from '@/shared/utils/date';
import FormattingTooltip from '@/components/basicComponents/tooltip/dollarsTooltip';
import {
  MobileRow,
  MobileRowTitle,
  MobileRowValue,
  MobileTableRowWrap,
  MobileTableWrapper,
  NoResults
} from '@/components/table/mobileTable/mobileTable';
import styled from 'styled-components';
import { TransformedAssetClassForecastValueDto } from '../../../../../types';
import MobileSubTotalRow from './mobileSubTotalRow';
import MobileSumFooter from './mobileSumFooter';

interface MobileTableProps {
  contributionsTableData: TransformedAssetClassForecastValueDto[];
  distributionsTableData: TransformedAssetClassForecastValueDto[];
}

const MobileTable = ({ contributionsTableData, distributionsTableData }: MobileTableProps) => {
  const TableRow = ({ el }: { el: TransformedAssetClassForecastValueDto }) => {
    return (
      <CustomMobileTableRowWrap key={el.name}>
        <MobileRow>
          <MobileRowTitle>Asset Class</MobileRowTitle>
          <MobileRowValue>{el.name}</MobileRowValue>
        </MobileRow>

        {el.values.map((item) => (
          <MobileRow key={el.name + item.date}>
            <MobileRowTitle>{getUTCDate(new Date(item.date)).toUpperCase()}</MobileRowTitle>
            <MobileRowValue>
              <FormattingTooltip zIndex={1000}>{item.value}</FormattingTooltip>
            </MobileRowValue>
          </MobileRow>
        ))}
      </CustomMobileTableRowWrap>
    );
  };

  return (
    <MobileTableWrapper>
      {contributionsTableData?.length || !distributionsTableData.length ? (
        <>
          <ContributionsRowWrapper>Contributions</ContributionsRowWrapper>
          {contributionsTableData.map((el) => {
            return <TableRow el={el} key={el.name} />;
          })}
          <MobileSubTotalRow tableData={contributionsTableData} />
          <ContributionsRowWrapper>Distribution</ContributionsRowWrapper>
          {distributionsTableData.map((el) => {
            return <TableRow el={el} key={el.name} />;
          })}
          <MobileSubTotalRow tableData={distributionsTableData} />
          <MobileSumFooter contributionsTableData={contributionsTableData} distributionsTableData={distributionsTableData} />
        </>
      ) : (
        <NoResults>No Results</NoResults>
      )}
    </MobileTableWrapper>
  );
};

export default MobileTable;

const CustomMobileTableRowWrap = styled(MobileTableRowWrap)`
  background-color: ${({ theme }) => theme.layer.base};
`;

const ContributionsRowWrapper = styled.div`
  border-radius: 4px;
  background: ${({ theme }) => theme.layer[3]};
  padding: 10px 20px;
  font-size: 16px;
  font-weight: 600;
  line-height: 22.4px;
  color: ${({ theme }) => theme.layer.base};
`;
